export const hdFonts = {
    header: {
        fontFamily: "PaytoneOne-Regular"
    },
    text: {
        fontFamily: "Mulish",
        fontWeight: 300
    },
    textLight: {
        fontFamily: "Mulish",
        fontWeight: 200
    },
    textItalic: {
        fontFamily: "Mulish",
        fontStyle: "italic"
    },
    textBold: {
        fontFamily: "Mulish",
        fontWeight: 800
    },
    textBoldItalic: {
        fontFamily: "Mulish",
        fontWeight: "bold",
        fontStyle: "italic"
    },
    textSemiBold: {
        fontFamily: "Mulish",
        fontWeight: 600
    },
    title: {
        fontFamily: "Nunito",
        fontWeight: 900
    },
    mono: {
        fontFamily: "OxygenMono-Regular"
    },
    light: {
        fontFamily: "Lato",
        fontWeight: 300
    },
    lightItalic: {
        fontFamily: "Lato",
        fontWeight: 300,
        fontStyle: "italic"
    },
    extraThin: {
        fontFamily: "Lato",
        fontWeight: 200
    },
    regular: {
        fontFamily: "Nunito",
        fontWeight: 400
    },
    bold: {
        fontFamily: "Nunito",
        fontWeight: 700
    },
    semiBold: {
        fontFamily: "Nunito",
        fontWeight: 600
    },
};
